import { useContext, useMemo } from 'react';
import { formatNumberWithCommas } from '@/modules/common/utils/format-numbers.ts';
import {
  SubscribeModal,
  SubscribeModalProps,
} from '@/modules/investor-dashboard/components/modals/SubscribeModal.tsx';
import {
  TransferModal,
  TransferModalProps,
} from '@/modules/investor-dashboard/components/modals/TransferModal.tsx';
import { DisclosureListItem, DropdownMenu, ModalProviderContext } from 'ui';
import { DotsHorizontalIcon } from 'ui/icons';
import { goodFormatUSDCurrency } from 'ui/utils';
import { RegisterWithInvestmentResponse, ShareholderExtendResponse, TransactionType } from 'api';

export interface InvestorInvestmentItemProps extends RegisterWithInvestmentResponse {
  shareholders: ShareholderExtendResponse[];
  current_entity_id: number;
  lastItem: boolean;
}

export const InvestorInvestmentItem = ({
  register_classes_info,
  name,
  shareholders,
  current_entity_id,
  id: register_id,
  lastItem,
}: InvestorInvestmentItemProps) => {
  const { openModal } = useContext(ModalProviderContext);

  const shareholderId = useMemo(
    () =>
      shareholders.find(
        ({ entity_id, register_id: registerId }) =>
          entity_id === current_entity_id && registerId === register_id,
      )?.id || 0,
    [current_entity_id, register_id, shareholders],
  );

  const handleOpenSubscribeModal = (modalProps: Omit<SubscribeModalProps, 'open' | 'onClose'>) => {
    openModal(SubscribeModal, modalProps);
  };

  const handleOpenTransferModal = (modalProps: Omit<TransferModalProps, 'open' | 'onClose'>) => {
    openModal(TransferModal, modalProps);
  };

  return (
    <>
      {register_classes_info?.map(
        ({ id, class_name, number_of_units, current_price_per_share }, index, all) => (
          <DisclosureListItem
            lastItem={lastItem && index === all.length - 1}
            key={`DisclosureListItem_${index}`}
            leftMainString={name}
            leftSubduedContentSet={[
              class_name,
              `${formatNumberWithCommas(number_of_units)} units/shares`,
              ' Div. reinvestment: Disabled', //todo: remove hardcode
            ]}
            rightMainString={`${goodFormatUSDCurrency(
              Math.round((number_of_units || 0) * current_price_per_share * 100) / 100,
            )}`}
            classes={{
              rightMainString: 'max-w-[200px] min-w-[140px]',
            }}
            rightSubduedString={`${formatNumberWithCommas(number_of_units)} units/shares`}
            rightAdditionalContent={
              <div className="w-[40px] h-[40px] flex items-center justify-center">
                <DropdownMenu
                  items={[
                    {
                      label: 'Subscribe',
                      onClick: () =>
                        handleOpenSubscribeModal({
                          register_id,
                          register_class_id: id,
                          register_class_name: class_name,
                          shareholder_id: shareholderId,
                          price_per_share: current_price_per_share,
                          mode: TransactionType.Subscription,
                        }),
                    },
                    {
                      label: 'Redeem',
                      onClick: () =>
                        handleOpenSubscribeModal({
                          register_id,
                          register_class_id: id,
                          register_class_name: class_name,
                          shareholder_id: shareholderId,
                          price_per_share: current_price_per_share,
                          mode: TransactionType.Redemption,
                        }),
                    },
                    {
                      label: 'Transfer',
                      onClick: () =>
                        handleOpenTransferModal({
                          from_shareholder_id: shareholderId,
                          register_class_id: id,
                          register_class_name: class_name,
                          price_per_share: current_price_per_share,
                          register_id,
                        }),
                    },
                    // {
                    //   label: 'Transactions history',
                    //   onClick: () =>
                    //     navigate({
                    //       pathname: investorDashboardPaths.static.transactionsHistory,
                    //       search: createSearchParams(params).toString(),
                    //     }),
                    // },
                  ]}
                  button={
                    <button>
                      <img src={DotsHorizontalIcon} alt="Loading..." />
                    </button>
                  }
                  placement="top-end"
                  className="w-[180px]"
                />
              </div>
            }
          />
        ),
      )}
    </>
  );
};
